import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UUID } from '../uuid.model';
import { IDeclaration } from './declaration.interface';

export class DeclarationPosition implements IDeclaration {
  public location: Coordinates;
  constructor(
    public readonly id: UUID,
    public readonly instant: dayjs.Dayjs,
    public readonly latitude: number,
    public readonly longitude: number
  ) {
    this.location = new Coordinates(this.latitude, this.longitude);
  }

  public static hydrate(obj: DeclarationPosition): DeclarationPosition {
    return new DeclarationPosition(
      obj.id,
      dayjs(obj.instant),
      obj.latitude,
      obj.longitude
      // Coordinates.hydrate({latitude: declarationPosition.latitude, longitude: declarationPosition.longitude}),
    );
  }
}
